(function () {
  Flint.file('errors/errors.js', function (require) {
    var _helpers = require('./helpers');

    Flint.view('Errors', function (view, on, $) {
      var error = null; //{ message: "hello", file: 'where' }
      var compileError = null;
      var runtimeError = null;
      var npmError = null;

      // only set error if there is an error, giving compile priority
      function setError() {
        if (compileError) view.set('error', error = (0, _helpers.niceCompilerError)(compileError));else if (runtimeError) view.set('error', error = (0, _helpers.niceRuntimeError)(runtimeError));else {
          view.set('error', error = null);
        }

        _helpers.browser.curError = error;
        view.updateSoft();
      }

      function close() {
        view.set('error', error = null);
        view.set('compileError', compileError = null);
        view.set('runtimeError', runtimeError = null);
        view.set('npmError', npmError = null);
        view.updateSoft();
      }

      _helpers.browser.on('compile:error', function () {
        (0, _helpers.log)('compile:error');
        view.set('compileError', compileError = _helpers.browser.data.error);
        setError();
        view.updateSoft();
      });

      _helpers.browser.on('runtime:error', function () {
        // if (runtimeError) return // prefer first error
        view.set('runtimeError', runtimeError = _helpers.browser.data);
        (0, _helpers.log)('runtime:error', runtimeError);
        setError();
        view.updateSoft();
      });

      _helpers.browser.on('npm:error', function () {
        view.set('npmError', npmError = (0, _helpers.niceNpmError)(_helpers.browser.data.error));
        (0, _helpers.log)('npm:error', npmError);
        view.updateSoft();
      });

      _helpers.browser.on('runtime:success', function () {
        (0, _helpers.log)('runtime:success');
        view.set('runtimeError', runtimeError = null);
        view.set('npmError', npmError = null);
        setError();
        view.updateSoft();
      });

      _helpers.browser.on('compile:success', function () {
        (0, _helpers.log)('compile:success');
        view.set('compileError', compileError = null);
        view.set('npmError', npmError = null);
        setError();
        view.updateSoft();
      });view.render(function () {
        return view.el(['Errors.Message', 1], {
          error: error,
          npmError: npmError,
          close: close
        });
      });
    });
  })
})();
//# sourceMappingURL=errors.js.map
